<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>
<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #homefilterdesk>
    <div class="figma4">
        <clever-airport [mode]="'home'" [title]="'Beliebig'" [ziel]="'Abflughafen'" matTooltip="Abflughafen">
        </clever-airport>
        <clever-airport [mode]="'home'" [title]="'Beliebig'" [inAll]="true" [ziel]="'Zielflughafen'"
            matTooltip="Zielflughafen"></clever-airport>
        @if(start() && end()) {
        <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)" [mode]="'home'"
            class="w300px"></clever-date>
        }
        <!-- <clever-dauer [mode]="'home'" [class.disableddauer]="type === 'oneway'"></clever-dauer> -->
        <clever-traveller [mode]="'home'" (sendRes)="resTraveler($event)"></clever-traveller>
        <!-- <button matTooltip="Mehr Filter" (click)="openclosemore()" matRipple>
             <mat-icon fontIcon="more_vert"></mat-icon>
         </button> -->
        <button (click)="gotoZiel()" class="custombutton">
            <img src="../../../../assets/tvg/search.svg" alt="search"/>
            <span>{{btntext()}}</span>
        </button>
    </div>
    <!-- <div class="tmp-inputs-wrapper">
        <div class="tmp-principal-wrapper">
            <div class="flexy">
                <button class="btnflug flugdesk tmp-top-left tmpnorightborder brn" [class.activebtn]="type === 'flight'"
                    (click)="switchType('flight')">
                    <span class="ellipsis">{{'Hin- und Rückflug' | i18n | async}}</span>
                </button>
                <button class="btnflug flugdesk tmp-bottom-left tmpnorightborder brn"
                    [class.activebtn]="type === 'oneway'" (click)="switchType('oneway')">
                    <span class="ellipsis">{{'nur Hinflug' | i18n | async}}</span>
                </button>
            </div>
            <clever-airport [mode]="'home'" [title]="'Abflug'" [ziel]="'Abflughafen'" matTooltip="Abflughafen">
            </clever-airport>
            <clever-airport [mode]="'home'" [title]="'Ziel'" [inAll]="true" [ziel]="'Zielflughafen'"
                matTooltip="Zielflughafen"></clever-airport>
            <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'home'" class="w300px"></clever-date>
            <clever-dauer [mode]="'home'" [class.disableddauer]="type === 'oneway'"></clever-dauer>
            <clever-traveller [mode]="'home'" (sendRes)="resTraveler($event)" [reisende]="filter?.reisendeResult"></clever-traveller>
            <button matTooltip="Mehr Filter" (click)="openclosemore()" matRipple>
                <mat-icon fontIcon="more_vert"></mat-icon>
            </button>
            <button class="tmpsearch tmpbtn tmp-left tmp-right" (click)="gotoZiel()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span>{{btntext}}</span>
            </button>
        </div>
        <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
    </div> -->
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-inputs-wrapper-mobile">


        <div class="figma4_mobile">
            <clever-airport [mode]="'home'" [title]="'Beliebig'" [ziel]="'Abflughafen'" matTooltip="Abflughafen">
            </clever-airport>
            <clever-airport [mode]="'home'" [title]="'Beliebig'" [inAll]="true" [ziel]="'Zielflughafen'"
                matTooltip="Zielflughafen"></clever-airport>
            @if(start() && end()) {
            <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w300px"></clever-date>
            }
            <!-- <clever-dauer [mode]="'home'" [class.disableddauer]="type === 'oneway'"></clever-dauer> -->
            <clever-traveller [mode]="'home'" (sendRes)="resTraveler($event)"></clever-traveller>
            <!-- <button matTooltip="Mehr Filter" (click)="openclosemore()" matRipple>
             <mat-icon fontIcon="more_vert"></mat-icon>
         </button> -->
            <button (click)="gotoZiel()" class="custombutton">
                <img src="../../../../assets/tvg/search.svg" alt="search"/>
                <span>{{btntext()}}</span>
            </button>
        </div>

        <!-- <div class="tmp-extrafilter-wraper-mobile w100">
            <div class="gr-btn-mobile">
                <button class="btnflug flugmobile jcent tmp-top-left w100 tmpnorightborder tmpnobottomborder"
                    [class.activebtn]="type() === 'flight'" (click)="switchType('flight')">
                    <span class="ellipsis">Hin- und Rückflug</span>
                </button>
                <button class="btnflug flugmobile jcent tmp-top-right w100 tmpnobottomborder"
                    [class.activebtn]="type() === 'oneway'" (click)="switchType('oneway')">
                    <span class="ellipsis">nur Hinflug</span>
                </button>
            </div>
            <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w100"></clever-date>
            <div class="gr-btn-mobile w100">
                <clever-airport [mode]="'home'" [title]="'Abflug'" [bottomleftradius]="false" [norightborder]="true"
                    [ziel]="'Abflughafen'" class="w50"></clever-airport>
                <clever-airport [mode]="'home'" [title]="'Ziel'" [bottomleftradius]="false" [norightborder]="false"
                    [inAll]="true" [ziel]="'Zielflughafen'" class="w50"></clever-airport>
            </div>
            <div class="gr-btn-mobile w100">
                <clever-dauer [mode]="'home'" class="w50" [bottomleftradius]="true"
                    [class.disableddauer]="type() === 'oneway'"></clever-dauer>
                <clever-traveller [mode]="'home'" class="w50" (sendRes)="resTraveler($event)"></clever-traveller>
            </div>
            <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
            <button matTooltip="Mehr Filter" class="tmp-mehrfilter-mobile" (click)="openclosemore()" matRipple>
                <mat-icon>more_horiz</mat-icon>
            </button>
            <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span>{{btntext()}}</span>
            </button>
        </div> -->
    </div>
</ng-template>

<ng-template #nohomefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="nohomefilterdesk"></ng-container>
    }
    }
</ng-template>


<ng-template #nohomemodeMobile>
    <ng-container *ngIf="smallVersion else mbfilter">
        <div class="tmp-inputs-wrapper-nohome-mobile">
            <div class="smallfilter-mobile-wrapper mat-elevation-z1" (click)="showMBMenu()">
                <div class="m05">
                    <span class="smallfilter-title">
                        {{type() === 'oneway' ? 'Nur Hinflug' : 'Hin- und Rückflug'}}
                    </span>
                    <div class="smallfilter-body">
                        <span class="smallitem">
                            <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)"
                                [mode]="'nohomesmall'"></clever-date> |
                        </span>
                        <span class="smallitem">
                            <clever-dauer [mode]="'nohomesmall'"></clever-dauer> |
                        </span>
                        <span class="smallitem">
                            <clever-traveller [mode]="'nohomesmall'" (sendRes)="resTraveler($event)"></clever-traveller>
                            P |
                        </span>
                    </div>
                </div>
                <button class="smallfilter-btn" (click)="showMBMenu()" matRipple>
                    <mat-icon fontIcon="search"></mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #mbfilter>
    <div class="smallfilterbig-mobile-wrapper">
        <div class="gr-btn-mobile">
            <button class="btnflug flugmobile jcent tmp-top-left w100 tmpnorightborder tmpnobottomborder"
                [class.activebtn]="type() === 'flight'" (click)="switchType('flight')">
                <span class="ellipsis">Hin- und Rückflug</span>
            </button>
            <button class="btnflug flugmobile jcent tmp-top-right w100 tmpnobottomborder"
                [class.activebtn]="type() === 'oneway'" (click)="switchType('oneway')">
                <span class="ellipsis">nur Hinflug</span>
            </button>
        </div>
        @if(start() && end()) {
        <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)" [mode]="'home'"
            class="w100"></clever-date>
        }
        <div class="gr-btn-mobile w100">
            <clever-airport [mode]="'home'" [title]="'Abflug'" [ziel]="'Abflughafen'" class="w50"></clever-airport>
            <clever-airport [mode]="'home'" [title]="'Ziel'" [inAll]="true" [ziel]="'Zielflughafen'"
                class="w50"></clever-airport>
        </div>
        <div class="gr-btn-mobile w100">
            <clever-dauer [mode]="'home'" class="w50" [bottomleftradius]="true"
                [class.disableddauer]="type() === 'oneway'"></clever-dauer>
            <clever-traveller [mode]="'home'" class="w50" (sendRes)="resTraveler($event)"></clever-traveller>
        </div>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span>{{btntext()}}</span>
        </button>
    </div>
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="tmp-inputs-wrapper-nohome">
        <div class="gr-btn-mobile">

            <div class="quicksearchmenubtn" [class.quicksearchmenubtnactive]="local_type() === 'flight'"
                (click)="switchType('flight')">
                <span>Hin- und Rückflug</span>
            </div>
            <div class="quicksearchmenubtn" [class.quicksearchmenubtnactive]="local_type() === 'oneway'"
                (click)="switchType('oneway')">
                <span>nur Hinflug</span>
            </div>
        </div>

        @if(start() && end()) {
        <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)" [mode]="'nohome'"
            class="w100"></clever-date>
        }
        <div class="gr-btn-mobile gp10">
            <clever-airport [mode]="'nohome'" [ziel]="'Abflughafen'" class="w50"></clever-airport>
            <clever-airport [mode]="'nohome'" [inAll]="true" [ziel]="'Zielflughafen'" class="w50"></clever-airport>
        </div>
        <clever-traveller [mode]="'nohome'" class="w100" (sendRes)="resTraveler($event)"></clever-traveller>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span>{{btntext()}}</span>
        </button>
    </div>
</ng-template>

<ng-template #moreFilter>
    <clever-flugextrafilter [mode]="'home'" [type]="type()" class="w100" (closeModal)="openclosemore()">
    </clever-flugextrafilter>
</ng-template>